import React from 'react';
import { Container, Typography, Box, IconButton, Link, Divider } from '@mui/material';
import { useNavigate, Link as RouterLink } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const TermsOfService: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Container maxWidth="md" sx={{ mt: 5, mb: 5 }}>
      <Box className="page-header">
        <Box className="title-row">
          <IconButton onClick={() => navigate(-1)} aria-label="go back">
            <ArrowBackIcon />
          </IconButton>
          <Typography variant="h4" component="h1" className="page-title">Terms of Service</Typography>
        </Box>
      </Box>

      <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
        Last updated: January 31, 2026
      </Typography>

      <Box sx={{ mt: 3 }}>
        <Typography variant="h6" gutterBottom>Acceptance of Terms</Typography>
        <Typography variant="body2" color="text.secondary" paragraph>
          By accessing or using Grocery Price Checker, you agree to be bound by these Terms of Service.
          If you do not agree to these terms, please do not use the service.
        </Typography>
      </Box>

      <Divider sx={{ my: 3 }} />

      <Box>
        <Typography variant="h6" gutterBottom>Account Responsibilities</Typography>
        <Typography variant="body2" color="text.secondary" paragraph>
          You are responsible for maintaining the security of your account credentials. You agree to provide
          accurate information when creating your account and to keep your login details confidential.
          You are responsible for all activity that occurs under your account.
        </Typography>
      </Box>

      <Divider sx={{ my: 3 }} />

      <Box>
        <Typography variant="h6" gutterBottom>Acceptable Use</Typography>
        <Typography variant="body2" color="text.secondary" paragraph>
          You agree not to misuse the service. This includes but is not limited to:
        </Typography>
        <Typography variant="body2" color="text.secondary" component="div">
          <ul style={{ margin: 0, paddingLeft: 20 }}>
            <li>Scraping or automated data collection from the service</li>
            <li>Attempting to gain unauthorized access to other accounts or systems</li>
            <li>Using the service for any illegal activity</li>
            <li>Abusing the service in a way that degrades performance for other users</li>
          </ul>
        </Typography>
      </Box>

      <Divider sx={{ my: 3 }} />

      <Box>
        <Typography variant="h6" gutterBottom>Price Data Disclaimer</Typography>
        <Typography variant="body2" color="text.secondary" paragraph>
          Price data on Grocery Price Checker is submitted by users and is not guaranteed to be accurate,
          complete, or up to date. Prices may vary by location, time, and availability. You should verify
          prices directly with the retailer before making purchasing decisions.
        </Typography>
      </Box>

      <Divider sx={{ my: 3 }} />

      <Box>
        <Typography variant="h6" gutterBottom>Intellectual Property</Typography>
        <Typography variant="body2" color="text.secondary" paragraph>
          The Grocery Price Checker application, including its design, code, and branding, is owned by us.
          You retain ownership of any data you submit to the service, including your grocery items, prices,
          and shopping lists. By submitting data, you grant us a non-exclusive, worldwide, royalty-free
          license to use, store, display, and process that data as necessary to provide and improve the
          service.
        </Typography>
      </Box>

      <Divider sx={{ my: 3 }} />

      <Box>
        <Typography variant="h6" gutterBottom>Termination</Typography>
        <Typography variant="body2" color="text.secondary" paragraph>
          We reserve the right to suspend or terminate accounts that violate these terms or engage in
          abusive behavior. You may delete your account at any time from your Account page.
        </Typography>
      </Box>

      <Divider sx={{ my: 3 }} />

      <Box>
        <Typography variant="h6" gutterBottom>Limitation of Liability</Typography>
        <Typography variant="body2" color="text.secondary" paragraph>
          Grocery Price Checker is provided "as is" without warranty of any kind. We make no guarantees
          regarding the accuracy of price data, service availability, or fitness for a particular purpose.
          To the fullest extent permitted by law, we shall not be liable for any damages arising from
          your use of the service.
        </Typography>
      </Box>

      <Divider sx={{ my: 3 }} />

      <Box>
        <Typography variant="h6" gutterBottom>Changes to Terms</Typography>
        <Typography variant="body2" color="text.secondary" paragraph>
          We may update these Terms of Service from time to time. Changes will be reflected by the
          "Last updated" date at the top of this page. Continued use of the service after changes
          constitutes acceptance of the updated terms.
        </Typography>
      </Box>

      <Divider sx={{ my: 3 }} />

      <Box>
        <Typography variant="h6" gutterBottom>Contact</Typography>
        <Typography variant="body2" color="text.secondary" paragraph>
          If you have questions about these Terms of Service, please{' '}
          <Link component={RouterLink} to="/contact" underline="hover">contact us</Link>.
        </Typography>
      </Box>
    </Container>
  );
};

export default TermsOfService;
